<template>
  <div :class="$style['tracking-css']">
    <div v-if="order != null"
         style="display: flex; padding-right: 20px; color:white; flex-direction: row; width: 100%; height: auto; background-color: #4b4a4a">
      کد سفارش:
      <span style="font-family: sans-serif; font-weight: bold; display: flex; justify-content: space-between; align-items: center;
                           margin-right: 15px; color: white">{{ ' ' + '#' + order.order_code }}</span>
    </div>
    <div id="mapOrder" :class="[$style['MainMapCss'], $style['scrollTop']]" v-if="order != null">
      <mapir v-if="order.order_type == 0" :apiKey="MapirApiKey" :center="center"
             :class="$style['MainMapCss_Sub']">
        <mapAttributionControl/>
        <mapNavigationControl position="top-right"/>
        <mapGeolocateControl position="top-left"/>
        <mapScaleControl position="top-left"/>
        <mapMarker
            :coordinates="mapData"
            :draggable="false">
          <img :src="orderShop.shop_icon" alt="" slot="marker" :class="$style['mapMarker']"
               style="width: 9%"/>
        </mapMarker>
      </mapir>
      <div v-else style="width: 100%; flex: 1">
        <div style="margin-top: 50%">
          <div :class="$style['contentTransaction']">
            <img style="width: 100px; height: 100px" :src="require('@/assets/image/cluna/app_logo.png')"/>
            <span>{{ getOrderState() }}</span>
          </div>
        </div>
      </div>

      <v-card :class="[$style['box-modal'], $style['tracking-css']]">
        <div :class="$style['headline-tv']">
          <h4>{{ orderShop.shop_name }}</h4>
          <span
              :style="'font-size: 13px; font-weight: bold; color: ' + order.status_color +';'">{{
              order.status_label
            }}</span>
        </div>
        <div style="border-bottom: 1px solid black; width: 100%; margin: 10px 0 10px 0">
        </div>
        <span style="margin-right: 5px; margin-left: 5px; font-weight: bold; font-size: 13px;">{{ getType() }}</span>
        <div
            style="display: flex;justify-content: space-between; font-size: 12px; align-items: center; margin-bottom: 15px">
          <p style="margin-right: 5px; font-size: 11px; margin-bottom: 0; margin-left: 5px">
            {{ getAddress() }}</p>
          <v-btn v-if="order.order_type == 0" style="margin-left: 5px; border-radius: 20px; background-color: #7ec352;
                     color: white; font-size: 12px" role="button" v-ripple @click="Route()">
            <v-icon style="font-size: 14px">explore</v-icon>
            مسیریابی
          </v-btn>
        </div>
        <div style="border-bottom: 1px solid black; width: 100%">
        </div>
        <div style="display: flex; font-size: 12px; margin-bottom: 10px; justify-content: center;margin-top: 17px;">
          <v-btn role="button" v-ripple @click="sendModal = true" style="font-size: 12px;
                     background-color: rgba(255,255,255,0);  color: black; margin-left: 10px">
            <v-icon style="font-size: 12px; margin-left: 5px; color: #7dc353">chat</v-icon>
            ارسال پیام به فروشگاه
          </v-btn>
          <v-btn role="button" v-ripple @click="callSupport()" style=" font-size: 12px;
                     background-color: rgba(255,255,255,0);  color: black;">
            <v-icon style="font-size: 12px; margin-left: 5px; color: #7dc353">contact_support</v-icon>
            تماس با پشتیبانی
          </v-btn>
        </div>
      </v-card>
    </div>

    <v-dialog v-model="sendModal" transition="scroll-y-transition">
      <v-card :class="[$style['box-modal'], $style['tracking-css']]">
        <div :class="$style['headline-tv']">
          <div :class="$style['backpages']" style="color:black "
               role="button" v-ripple @click="sendModal = false">
            <v-icon style="font-size: 14px">close</v-icon>
          </div>
        </div>
        <div style="padding: 10px">
          <h5 style="color: #7dc353; font-size: 13px">ارسال پیام به فروشگاه</h5>
          <span style="font-size: 10px">جهت ارتباط با فروشگاه پیام مورد نظر خود را انتخاب کرده و ارسال نمایید</span>
        </div>
        <div :class="$style['BtnMessage']">
                    <span :class="selectOption == index ? $style['BtnMessageSelect'] : ''"
                          v-for="(item, index) in allMessage"
                          :key="index" role="button" v-ripple @click="MessageClick(index)">{{ item.title }}</span>
          <v-btn style="font-size: 12px; width: 100%;
                     background-color:#7dc353;  color: white; margin-left: 10px" role="button" v-ripple
                 @click="SentMessageData()">
            ارسال پیام
          </v-btn>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="sendModal2" transition="scroll-y-transition">
      <v-card :class="[$style['box-modal'], $style['tracking-css']]">
        <div style="padding: 10px">
          <h5 style="color: #555555; font-size: 13px">پیام دلخواه خود را برای فروشگاه بنویسید. (حداکثر 120
            کاراکتر)</h5>
        </div>
        <div>
          <v-textarea v-model="customText"
                      style="background-color: #eeeaea; padding: 15px"
                      placeholder="مثلا: فقط ساندویچ کلاب گرم شود!"></v-textarea>
        </div>
        <div :class="$style['BtnMessageSend']">
          <v-btn role="button" v-ripple @click="selectOption=7, SentMessageData()" style="font-size: 12px; width: 50%;
                     background-color: rgba(255,255,255,0);  color: #7dc353; ">
            ارسال پیام
          </v-btn>
          <v-btn style="font-size: 12px; width: 50%;
                    background-color: rgba(255,255,255,0);  color: #555555;"
                 role="button" v-ripple @click="sendModal2 = false,  sendModal = true ">
            بازگشت
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import oracle from "@/utils/oracle";
import {
  mapir,
  mapMarker,
  mapAttributionControl,
  mapNavigationControl,
  mapGeolocateControl,
  mapScaleControl,
} from "mapir-vue";

export default {
  name: "Tracking",
  components: {
    mapir,
    mapNavigationControl,
    mapMarker,
    mapAttributionControl,
    mapGeolocateControl,
    mapScaleControl,
  },
  data() {
    return {
      customText: '',
      id: null,
      delivery_time: 0,
      orderShop: null,
      order: null,
      MapirApiKey: "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6Ijc3OTZjOTI0MGJlNzA2ODFhZjkwOGZmNjJkMmNmZDZjZGEyZGZiYjg5ZTk1YzYwYmI5ODFkZDA1ZGM4YWUzMDdlZmE1YmEwMGEwMDUyNTcxIn0.eyJhdWQiOiIxMjg0MyIsImp0aSI6Ijc3OTZjOTI0MGJlNzA2ODFhZjkwOGZmNjJkMmNmZDZjZGEyZGZiYjg5ZTk1YzYwYmI5ODFkZDA1ZGM4YWUzMDdlZmE1YmEwMGEwMDUyNTcxIiwiaWF0IjoxNjEzNTYxNDIwLCJuYmYiOjE2MTM1NjE0MjAsImV4cCI6MTYxNjA2NzAyMCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.PGE1y2V5xX6kKL5qG08k21qZ5fzge8RD_DaBkMuQW7vOdHFzwnM1rGnuiCQ9dPw7irbURXkNT5SdLRWGAjDzahK4dH6Y4QT3DScuEm05ZSozzgWaBMNDdQmBF8-Hi01StkZqBP4wrZMLO1PpxgEe9zjbZRSY_yfFr4usUuSyYeYxT3DPo4GrDz7WFWzpl73mKl30ka_THDdPj0d3f_cnwAOsZuETS3hzeb_duplYGIbwJAFZ4OsTlVKYnxPp8lHyboa3rwP0I3inQB2o-lzZFJjsEGZYhVKZeayUR_3t4DthI52NJvJDvTYb-yAs5zXcm6vWDnWEc0Kd9pp45qPcAQ",
      center: [51.420296, 35.732379],
      mapData: [],
      tel: null,
      sendModal: false,
      sendModal2: false,
      items: ['همه فروشگاه ها', 'سفارش دلیوری', 'سفارش آنلاین'],
      allMessage: [
        {title: 'لطفا سفارش من گرم شود'},
        {title: 'تا ده دقیقه دیگر به فروشگاه میرسم'},
        {title: 'با تاخیر میرسم'},
        {title: 'زودتر خواهم رسید'},
        {title: 'بیرون فروشگاه منتظر هستم'},
        {title: 'جلوی درب فروشگاه داخل اتومبیل منتظر هستم'},
        {title: 'پیام خود را به صورت دلخواه بنویسید ...'},
      ],
      selectOption: null,
    };
  },
  methods: {
    getType() {
      if (this.order.order_type == 0) {
        return 'تحویل حضوری درب فروشگاه'
      } else {
        return 'تحویل با پیک درب منزل'
      }
    },
    getAddress() {
      if (this.order.order_type == 0) {
        return this.orderShop.shop_address
      } else {
        return this.order.order_address.address_description
      }
    },
    callSupport() {
      window.open("tel:" + this.tel, '_blank');
    },
    MessageClick(i) {
      this.selectOption = i
    },
    SentMessageData() {
      if (this.selectOption == 6) {
        this.sendModal = false
        this.sendModal2 = true
      } else {
        oracle.axios("event/create", {
          "order_id": this.id,
          "event_message": this.selectOption == 7 ? this.customText : this.allMessage[this.selectOption].title,
          "shop_id": this.orderShop.shop_id
        }, (response) => {
          this.sendModal = false
          this.sendModal2 = false
          oracle.showMessage("ارسال پیام به فروشگاه: \nپیام شما با موفقیت ثبت شد.", null, null, true)
        })
      }
    },
    Route() {
      let link = "https://www.google.com/maps/@" + this.mapData[1] + "," + this.mapData[0] + ",19z"
      window.open(link, '_blank');
    }, getOrderState() {
      let time = oracle.formatDate(this.order.create_at + (this.delivery_time * 60 * 1000)).split(" ")[1]
      switch (this.order.order_state) {
        case 0:
        case 2:
        case 3:
        case 4:
        case 5:
          return "سفارش شما به صورت تقریبی تا ساعت " + time + " به شما تحویل داده خواهد شد"
        case 1:
          return 'این سفارش لغو شده است'
        case 6:
          return 'این سفارش با موفقیت تحویل داده شد'
      }
    }
  },
  mounted() {
    this.id = this.$route.query.id
    oracle.axios("setting/getInfo", {"filter_by": "website", 'search_by': 'delivery_time'}, (result) => {
      this.delivery_time = result.data;
      oracle.axios("setting/getInfo", {"filter_by": "website", 'search_by': 'support'}, (res) => {
        this.tel = res.data;
        oracle.axios(
            "order/getOne",
            {"order_id": this.id},
            (response) => {
              if (response.data.order_refund == 1) {
                response.data.status_label = "ریفاند به کیف پول"
                response.data.status_color = '#ffab04'
              } else if (response.data.order_refund == 2) {
                response.data.status_label = "ریفاند به حساب بانکی"
                response.data.status_color = '#ffab04'
              } else {
                response.data.status_color = '#222222'
                switch (response.data.order_state) {
                  case 0:
                    response.data.status_label = 'ثبت شده'
                    break
                  case 1:
                    response.data.status_color = '#ff0000'
                    response.data.status_label = 'لغو شده'
                    break
                  case 2:
                    response.data.status_label = 'جستجوی پیک'
                    break
                  case 3:
                    response.data.status_label = 'پذیرش میاره'
                    break
                  case 4:
                    response.data.status_label = 'پیک یافت شد'
                    break
                  case 5:
                    response.data.status_label = 'پیک در فروشگاه'
                    break
                  case 6:
                    response.data.status_color = '#7ec352'
                    response.data.status_label = 'تحویل مشتری'
                    break
                }
              }
              this.order = response.data;
              this.orderShop = response.data.shop;
              this.mapData = [response.data.shop.shop_longitude, response.data.shop.shop_latitude]
              this.IsLoadMap = true;
            }
        );
      });
    });
  },
};
</script>
<style module>

.tracking-css {
  display: flex;
  flex-direction: column;
}

.tracking-css .headline-tv {
  margin-top: 10px;
  padding-left: 5px;
  padding-right: 5px;
  display: flex;
  justify-content: space-between;
}

.tracking-css .box-modal {
  background-color: white !important;
  padding: 5px 5px;
  position: fixed;
  bottom: 0;
  width: 100%;
  left: 0;
}

.tracking-css .MainMapCss_Sub {
  display: flex;
  position: absolute;
  left: 0;
}

.tracking-css .map {
  width: 100%;
  height: 100%;
}

.tracking-css .MainMapCss {
  left: 0;
  height: auto !important;
}

.tracking-css .BtnMessageSend {
  display: flex;
}

.tracking-css .BtnMessage {
  width: 100%;
  background-color: #e0dede;
  display: flex;
  flex-direction: column
}

.tracking-css .BtnMessage span {
  text-align: center;
  height: 35px;
  display: flex;
  align-items: center;
  font-size: 12px;
  justify-content: center
}

.tracking-css .BtnMessageSelect {
  background-color: #555555;
  color: white;
}

.tracking-css .contentTransaction {
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
}

.tracking-css .contentTransaction span {
  margin-top: 20px;
  font-size: 13px;
  text-align: center;
  margin-left: 20px;
  margin-right: 20px;
}
</style>
